/**
 * Inventory — separate card for TikTok inventory quantity editing.
 * Uses instant TikTok API (no audit required).
 *
 * Extracted from MarketplacePackageWidget (Epic 05) because
 * inventory is a high-frequency edit and deserves its own card.
 */

import type { ExperienceWidgetProps } from "@/lib/views/widgets/registry";
import { getChannelConfig } from "./shared";
import { EditableSettingsRow } from "./EditableSettingsRow";
import { useTikTokEditStore, selectIsFieldDirty } from "../stores/useTikTokEditStore";

export function MarketplaceInventoryWidget({ section, formData }: ExperienceWidgetProps) {
  const channel = section.description || "";
  const config = getChannelConfig(channel);
  const quantity = formData?.[config.quantity] as number | undefined;
  const isDirty = useTikTokEditStore(selectIsFieldDirty("inventory_quantity"));

  // Hide if no quantity data and not being edited
  if (quantity == null && !isDirty) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide pl-4 mb-2">
        Inventory
      </h3>
      <div className="rounded-2xl overflow-hidden bg-card">
        <EditableSettingsRow
          label="Quantity"
          value={quantity}
          fieldKey="inventory_quantity"
          editType="number"
          placeholder="0"
        />
      </div>
    </div>
  );
}
